import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import type { ReportsViewType } from '../../pages/types';
import { MaterialIcon, Toggle } from '../../components';
import { APP_THEME } from '../../styles/theme/styled/theme';
import icon from '../../components/charts/icons/TwoPeople.svg';
import { useLocalStorage } from 'react-use';

export const useReportViewToggle = (): (React.ReactElement | ReportsViewType | null)[] => {

  const [ toggle, setToggle ] = useState(<></>);
  const [ value = 'charts', setValue ] = useLocalStorage<ReportsViewType>('view_type', 'charts');

  useEffect(() => {
    setToggle(
      <div className={'flex mx-auto'} style={{
        height: APP_THEME.sizes.md,
        minWidth: 150,
      }}>
        <div
          className={'bg-white flex items-center justify-center w-full px-4'}
          style={{
            boxShadow: APP_THEME.shadows.md,
            borderRadius: APP_THEME.radius.input,
          }}
        >
          <button className={'appearance-none'} onClick={() => setValue('charts')}>
            <img
              src={icon}
              width={30}
              height={'auto'}
              alt={'Charts view'}
              className={classnames({ 'opacity-50' : value !== 'charts' })}
            />
          </button>
          <div className={'ml-3 mr-sm'}>
            <Toggle
              id={'report-view'}
              label={'Report view'}
              color={'header'}
              checked={value === 'table'}
              onChange={() => {
                setValue(value === 'table' ? 'charts' : 'table');
              }}
            />
          </div>
          <button className={'appearance-none'} onClick={() => setValue('table')}>
            <MaterialIcon
              icon={'ViewList'}
              color={'dark'}
              className={classnames({ 'opacity-50' : value !== 'table' })}
              size={34}
              hasContainer={false}
            />
          </button>
        </div>
      </div>,
    );
  }, [ value ]);

  return [ toggle, value ];
};
